import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import styles from './Button.module.scss';
import UseThemeColors from '@/school-management/hooks/useThemeColors';
import AppIcon from '../AppIcon/AppIcon';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  block?: boolean;
  loading?: boolean;
  isTransparent?: boolean;
  secondary?: boolean;
  isTextButton?: boolean;
  isBack?: boolean;
  isDelete?: boolean;
  onBack?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  isBack,
  secondary,
  block,
  children,
  loading,
  isTransparent,
  isTextButton = true,
  isDelete,
  onBack,
  ...props
}) => {
  const { color } = UseThemeColors();
  const navigate = useNavigate();
  const isDisabled = loading || props.disabled;
  return (
    <button
      {...props}
      className={clsx(styles.appButton, props.className, {
        [styles.block]: block,
        [styles.transparent]: isTransparent,
        [styles.secondary]: secondary,
        [styles.Main]: !secondary,
        [styles.textButton]: isTextButton,
        [styles.back]: isBack,
        [styles.delete]: isDelete,
        [styles.disabled]: isDisabled,
      })}
      disabled={isDisabled}
      onClick={event => {
        if (isBack) {
          if (typeof onBack === 'function') {
            onBack();
          } else {
            navigate(-1);
          }
        }
        props.onClick?.(event);
      }}
    >
      {!loading && isBack && (
        <span className={styles.chevron} aria-hidden='true'>
          <AppIcon
            icon='ArrowLeft'
            size={24}
            style={{ width: '17px', height: '17px', marginTop: '4px' }}
          />
        </span>
      )}

      {isDelete && <AppIcon icon='deleteIcon' size={24} />}
      {!loading && children}
      {loading && <BeatLoader color={color('white-regular')} size={10} />}
    </button>
  );
};

export default Button;
